<template>
  <!-- 提款申请页面 -->
  <div id="withdrawalRequest">
    <Form
      :model="form"
      :rules="rules"
      v-model="regular"
    >
      <Input
        class="temr"
        label="企业名称"
        :readonly="true"
        v-model="form.corpName"
        :labelWidth="labelWidth"
      />
      <Input
        class="temr"
        label="借款人姓名"
        v-model="form.borrowerName"
        :readonly="true"
        :labelWidth="labelWidth"
      />

      <div class="company">
        <DrawAmtInput
          class="temr"
          :placeholder="placeholderDrawAmt"
          v-model="form.drawAmt"
          :reg="rules.drawAmt"
          :labelWidth="labelWidth"
          :ispayLimit="form.usableAmount"
          label="申请金额"
        />
        <span>元</span>
      </div>
      <SelfSelect
        label="申请期限"
        placeholder="请选择申请期限"
        v-model="form.term"
        @selectValues="selectValues"
        :columnsTerm="form.loanTermMap"
        :labelWidth="labelWidth"
      />
      <SelfSelect
        label="还款方式"
        placeholder="请选择还款方式"
        v-model="form.rtnTypes"
        :columnsTerm="form.columnsTermMethod"
        :labelWidth="labelWidth"
      />
      <SelfSelect
        label="放款方式"
        placeholder="请选择放款方式"
        v-model="form.payment"
        :columnsTerm="form.paymentMap"
        :defaultValue="paymentDefault"
        :labelWidth="labelWidth"
      />

      <!-- 0自主支付 1受托支付 -->
      <div v-if="form.payment === '0'">
        <Input
          class="temr"
          label="银行名称"
          placeholder="请输入银行名称"
          v-model="form.openBankName"
          maxlength="20"
          :labelWidth="labelWidth"
        />
        <Input
          class="temr other-width"
          label="银行卡号"
          placeholder="请输入本人名下的个人银行卡"
          v-model="form.openBankNo"
          maxlength="20"
          :labelWidth="labelWidth"
        />
        <Input
          class="temr"
          label="银行预留手机号"
          v-model="form.borrowerPhone"
          maxlength="11"
          :reg="rules.phone"
          :labelWidth="labelWidth"
        />
        <OwnMessageCode
          v-model="form.captcha"
          :reg="rules.captcha"
          label="短信验证码"
          :params="{
            orderId: form.orderId,
            smsUrl: form.smsUrl,
            borrowerPhone: form.borrowerPhone,
            openBankNo: form.openBankNo,
            openBankName: form.openBankName,
            type: '5'
          }"
          :labelWidth="labelWidth"
        />
      </div>
      <div v-else>
      <AccountSelect
        label="放款账户名称"
        placeholder="请选择放款账户名称"
        v-model="form.custName"
        :getSelect="getSelect"
        :columnsTerm="custNameList"
        :labelWidth="labelWidth"
      />
      <div class="company">
        <Input
        class="temr"
        label="受托支付限额"
        v-model="form.selfPaymentLimit"
        :labelWidth="labelWidth"
      />
      <span>元</span>
      </div>
      <Input
        class="temr"
        label="开户行名称"
        v-model="form.openBankMentName"
        :labelWidth="labelWidth"
      />
      <Input
        class="temr"
        label="开户行行号"
        :reg="rules.bankCode"
        v-model="form.payeeBankCode"
        :labelWidth="labelWidth"
      />
      <Input
        class="temr"
        label="放款账号"
        v-model="form.openBankMentNo"
        :labelWidth="labelWidth"
      />
      <Input
        class="temr"
        label="附言"
        v-model="form.postscript"
        :labelWidth="labelWidth"
        maxlength="34"
      />
      </div>
      <Contract
        text="本人已阅读并完全同意"
        :list="contractList"
        :defaultCheck="false"
        v-model="isAgree"
      />
    </Form>
    <SelfButton
      :loading="loading"
      loadingText="提交中..."
      text="提交"
      type="danger"
      :disabled="!isDisabled"
      class="nextStep"
      :click="submitWithdrawalInfo"
    />

    <DrawMoneyTips :changeTipsShow="changeTipsShow" v-if="tipsShow && this.$route.query.productId == 'YL-YPD'"></DrawMoneyTips>
    <server-bank
      v-else
      :productId="this.$route.query.productId"
      :isRelative="true"
    ></server-bank>

    <self-popup
      v-model="showContent"
      @define="define"
    ></self-popup>
  </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex';
import { getIPaddressAndwechatAccessLocation } from '@/utils/index';
// import { milliFormat } from '@/utils';
import ServerBank from '@/components/ServerBank.vue';
import { Toast } from 'vant';
import Contract from '@/components/Contract.vue';
import DrawAmtInput from './components/DrawAmtInput.vue';
import AccountSelect from './components/AccountSelect.vue';
import OwnMessageCode from './components/MessageCode.vue';
// import SelectInput from './components/SelectInput.vue';
import SelfSelect from './components/SelfSelect.vue';
import DrawMoneyTips from './components/DrawMoneyTips.vue';

export default {
  name: 'withdrawalRequest',
  components: {
    DrawAmtInput,
    AccountSelect,
    OwnMessageCode,
    // SelectInput,
    SelfSelect,
    ServerBank,
    Contract,
    DrawMoneyTips,
  },
  data() {
    return {
      contractList: [
        {
          text: '个人贷款资金支付委托书',
          value: 'yl_zfwt',
        },
        {
          text: '借款合同',
          value: 'YiLianJKContract',
        },
      ],
      isAgree: false,

      labelWidth: '129px',
      loading: false,
      paymentDefault: '',
      paymentInitArr: [],
      time: null,
      form: {
        orderId: this.$route.query.orderId,
        corpName: '', // 企业名称
        borrowerName: '', // 借款人姓名
        drawAmt: '', // 申请金额
        term: '', // 申请期限
        payment: '0', // 支付方式
        rtnTypes: '', // 还款方式
        corporateAccount: '', // 对公账户标志 1本行 2他行
        borrowerPhone: '', // 银行预留手机号
        captcha: '', // 短信验证码
        selfPaymentLimit: '', // 自主支付限额
        // selfPaymentLimitNumber: '',
        custName: '', // 放款账户名称
        loanBankNo: '', // 贷款入账账号
        loanBankName: '', // 贷款入账账户名称
        openBankNo: '', // 开户行行号
        openBankName: '', // 开户行名称
        openBankMentNo: '', // 受托支付账号
        openBankMentName: '', // 受托支付银行
        rePayAcctNumber: '', // 账户账号
        rePayAcctName: '', // 账号名称
        payeeBankCode: '', // 开户行行号
        typeList: ['yl_wtkk', 'yl_jk'],
        postscript: '', // 附言
      },
      // usableAmount: '', // 剩余可提款额
      // showAccountDetails: false, // TODO-YXF 字段无注释
      custNameList: [], // 受托支付账户列表 -苏宁不用，亿联启用
      // taxNo: '', // TODO-YXF 字段待确认
      showContent: '',
      regular: false,
      rules: {
        term: [{ required: true }],
        payment: [{ required: true }],
        rtnTypes: [{ required: true }],
        drawAmt: [
          {
            pattern: /^[1-9]\d{0,}$/,
            message: '申请金额格式输入有误,只能输入不以0开头的整数',
          },
        ],
        openBankName: [{ required: true }],
        openBankNo: [{ required: true }],
        captcha: [{ pattern: /^\d{6}$/, message: '请输入6位数字的验证码' }],
        phone: [{ pattern: /^1\d{10}$/, message: '请输入正确手机号' }],
        bankCode: [{ pattern: /^[0-9]*$/, message: '只可输入数字' }],
      },
      // 最新的可提款额度
      newLimit: 0,
      tipsShow: true,
    };
  },
  computed: {
    ...mapState({
      commonForms(val) {
        return val.commonForms;
      },
    }),
    isDisabled() {
      const {
        drawAmt,
        usableAmount,
      } = this.form;
      if (parseInt(drawAmt || 0, 10) > parseInt(usableAmount, 10)) {
        return false;
      }
      if (!this.isAgree) {
        return false;
      }
      return this.regular;
    },
    placeholderDrawAmt() {
      return `剩余可提款额${this.form.usableAmount || ''}`;
    },
  },
  beforeCreate() {
    if (!this.$route.query.passthrough) {
    // 浦发流程合规修改，去掉征信授权书签署、征信授权书签署成功两页面，所以后端不动，前端自动重定向
      this.$router.push(`/supermarket/v2/faceRecognitionPre?orderId=${this.$route.query.orderId}&productId=${this.$route.query.productId}`);
    }
  },
  created() {
    getIPaddressAndwechatAccessLocation();
    this.getWithdrawalInfo(); // 获取页面反显信息
  },
  mounted() {

  },
  watch: {
    'form.openBankNo': {
      handler(val) {
        this.debounce(async () => {
          const res = await this.$api.OtherPage.yilianQueryBankInfo({
            bankNo: val,
          });
          if (res.success && res.data.length > 0) {
            this.form.openBankName = res.data[0].bankName;
          }
        }, 1000);
      },
    },
    'form.payment': {
      handler(val) {
        this.getCustNameList(); // 获取受托支付列表
        if (val === '1') {
          delete this.rules.openBankName;
          delete this.rules.openBankNo;
          delete this.rules.borrowerPhone;
          delete this.rules.captcha;
          this.form.openBankName = '';
          this.form.openBankNo = '';
          this.form.borrowerPhone = '';
          this.form.captcha = '';

          this.rules.payeeBankCode = [{ required: true }];
          this.rules.openBankMentNo = [{ required: true }];
          this.tipsShow = true;
        } else {
          delete this.rules.custName;
          delete this.rules.selfPaymentLimit;
          delete this.rules.openBankMentName;
          delete this.rules.payeeBankCode;
          delete this.rules.openBankMentNo;
          this.form.selfPaymentLimit = '';
          this.form.openBankMentName = '';
          this.form.payeeBankCode = '';
          this.form.openBankMentNo = '';

          this.rules.openBankName = [{ required: true }];
          this.rules.openBankNo = [{ required: true }];
          this.rules.borrowerPhone = [{ pattern: /^1\d{10}$/, message: '请输入正确手机号' }];
          this.rules.captcha = [{ pattern: /^\d{6}$/, message: '请输入6位数字的验证码' }];
        }
      },
    },
    'form.drawAmt': {
      handler(val) { // 金额大于50w需要换成受托支付，否则自主
        if (val > 500000) {
          this.paymentDefault = '1';
          this.form.paymentMap = [this.paymentInitArr.find((e) => e.text === '受托支付')];
        } else {
          this.paymentDefault = '0';
          this.form.paymentMap = JSON.parse(JSON.stringify(this.paymentInitArr));
        }
      },
    },
    'form.corporateAccount': {
      handler(val) {
        // 对公账户标志为本行账户时隐藏该字段, 则取消校验 (两处判断了该状态为0情况，如修改需要同时修改)
        if (val === '1') {
          // 更新form校验
          const t = this.form.openBankNo;
          this.form.openBankNo = '';
          setTimeout(() => {
            this.form.openBankNo = t;
          }, 100);
          this.rules.openBankNo = [{ required: true }];
          this.rules.openBankName = [{ required: true }];
        } else {
          delete this.rules.openBankNo;
          delete this.rules.openBankName;
        }
      },
    },
  },
  methods: {
    ...mapMutations('commonForms', ['updateForm']),

    getSelect(val) {
      this.form.selfPaymentLimit = val.credit_amount;
      this.form.openBankMentNo = val.bank_no;
      this.form.openBankMentName = val.bank_name;
      this.form.payeeBankCode = val.openBankNo;
    },
    debounce(fn, delay) {
      if (this.time !== null) {
        clearTimeout(this.time);
      }
      this.time = setTimeout(() => {
        fn.call(this);
      }, delay);
    },

    async getCustNameList() {
      const res = await this.$api.OtherPage.getYiLianPayment({
        orderId: this.$route.query.orderId,
        type: '1',
      });
      if (res.success) {
        this.custNameList = res.data.list;
      }
    },

    // 获取页面反显信息
    async getWithdrawalInfo() {
      const { data } = await this.$api.OtherPage.queryEchoInfo({
        orderId: this.$route.query.orderId,
      });

      this.form = {
        ...this.form,
        ...data,
      };
      this.paymentInitArr = data.paymentMap;
    },

    // 提款提交
    async submitWithdrawalInfo() {
      if (this.form.payment === '1' && parseFloat(this.form.drawAmt) > this.form.selfPaymentLimit) {
        Toast('申请金额不能大于受托支付限额');
        return;
      }
      try {
        this.loading = true;
        const { success, returnMessage } = await this.$api.OtherPage.commitApply(this.form);
        this.loading = false;
        if (success) {
          this.$store.dispatch('otherPages/jumpCurrPageServer');
        } else {
          this.showContent = returnMessage;
        }
      } catch (e) {
        Toast('提款提交失败');
        this.loading = false;
      }
    },

    // 申请期限选择器form赋值，如字段量大可采用解构赋值
    selectValues(e) {
      this.form.termOptCode = e.termOptCode;
      this.form.termUnit = e.termUnit;
    },

    // 开户行名称模糊查询及开户行行号自动反显
    getOpenBankInfo(e) {
      this.form = {
        ...this.form,
        ...e,
      };
    },

    // 点确定跳转下一页面
    define(obj) {
      this.$store.dispatch('otherPages/jumpCurrPageServer');
      // eslint-disable-next-line no-unused-expressions
      obj.cb && obj.cb();
    },
    changeTipsShow(e) {
      this.tipsShow = e;
    },
  },
};
</script>
<style scoped>
#withdrawalRequest {
  width: 100%;
  height: 100%;
  background: #fff;
}
#withdrawalRequest >>> .van-field__label {
  width: 129px;
  margin-right: 0;
  color: #1c2438;
}
.temr::after {
  position: absolute;
  right: 16px;
  bottom: 0;
  left: 16px;
  box-sizing: border-box;
  border-bottom: 1px solid #dddee1;
  -webkit-transform: scaleY(0.5);
  transform: scaleY(0.5);
  content: " ";
  pointer-events: none;
}
#withdrawalRequest >>> .van-button--disabled {
  opacity: 1;
  color: #fff;
  background-color: #bac8d1 !important;
  border: 1px solid #bac8d1 !important;
}
.mt8 {
  padding-top: 8px;
}
.nextStep {
  margin-top: 30px;
  margin-bottom: 12px;
}
.getCode {
  color: rgba(246, 82, 73, 1);
  font-weight: 400;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
}
.code_btn {
  position: absolute;
  right: 14px;
  bottom: 7px;
  z-index: 3;
  width: auto;
  height: 35px;
  background: #fff;
  border: none;
}
.company {
  position: relative;
}
.company > span {
  position: absolute;
  top: 12px;
  right: 16px;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #1c2438;
}
.company >>> .cross {
  margin-right: 38px;
}
.other-width >>> input{
  width: 100%;
}
</style>
